
import React from 'react';
import { NavBarTimeFrame } from '@/components/navbar/NavBarTimeFrame';
import { TimeFrameOption } from '@/components/business/leads/utils/dateFilters';

interface MobileTimeFrameSectionProps {
  timeFrame: TimeFrameOption;
  onTimeFrameChange: (value: TimeFrameOption) => void;
}

const MobileTimeFrameSection: React.FC<MobileTimeFrameSectionProps> = ({ 
  timeFrame, 
  onTimeFrameChange 
}) => {
  return (
    <div className="px-4 mb-4">
      <NavBarTimeFrame 
        timeFrame={timeFrame} 
        onTimeFrameChange={onTimeFrameChange} 
        isMobile={true} 
      />
    </div>
  );
};

export default MobileTimeFrameSection;
